import { apiClient, makeServicePlugin, BaseModel } from '@/api'

class Bot extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Bot'
  // Define default properties here
  static instanceDefaults() {
    return {
      username: null,
      first_name: null,
      last_name: null,
      token: null,
      bot_tg_id: null,
      account_id: null,
      app_name: null,
      app_id: null,
      app_url: null,
      dyno_id: null,
      dyno_state: null,
      db_url: null,
      db_schema: null,
      redis_url: null,
      plan_id: null,
      api_key: null,
      member_count: 0,
      active: false,
      properties: {}
    }
  }
}

const servicePath = 'bots'
const servicePlugin = makeServicePlugin({
  Model: Bot,
  service: apiClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
apiClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin